import React from 'react';

const NotFound = (props) => {
  return (
    <h2>Esta pagina no existe</h2>
  )
}

export default NotFound;